import React from 'react'
import ExcelAnswerTable from './ExcelAnswerTable'
import './excel-answer-table.scss'

const ExcelAnswerTablesGroup = ({ answers, studentMode = false }) => {
    const answerPanels = answers?.map((answer, index) => (
        <ExcelAnswerTable key={index} answer={answer} studentMode={studentMode} />
    ))

    return <>{answerPanels}</>
}

export default ExcelAnswerTablesGroup
